import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IPaginationResultFrequencies,
  IRequestResult,
} from "../../../../../common/interfaces";
import { environment as env } from "../../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../../services/abstract.service";
import BusinessPartnerContactFunctionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-contact-function/business-partner-contact-function.entity";
import { ICreateFunctionContact } from "./interface/create-bp-contact-function.interface";
import { IUpdateFunctionContact } from "./interface/update-bp-contact-function.interface";


const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business_partner_contact_function";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerContactFunctionService extends AbstractService<
  BusinessPartnerContactFunctionAttributes,
  ICreateFunctionContact,
  IUpdateFunctionContact
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<BusinessPartnerContactFunctionAttributes>,
  ): Observable<IPaginationResult<BusinessPartnerContactFunctionAttributes>> {
    const query = buildQuery<BusinessPartnerContactFunctionAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("name", Ops.like(options.search ?? "", "i")),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );
    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<BusinessPartnerContactFunctionAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<BusinessPartnerContactFunctionAttributes[]>> {
    const query = buildQuery<BusinessPartnerContactFunctionAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["code", "name"]),
      orderBy("code", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<BusinessPartnerContactFunctionAttributes[]>>(API_URL);
  }
}
